
<template>
  <div style="display:flex">
    <div class="box" style="width:100%;">
      <div class="boxTitle" style="margin:15px">国家贸易额</div>
      <div class="echart">
        <dv-scroll-board :config="config1" style="width:100%;height:30vh" />
      </div>
    </div>

  </div>

</template>

<script>
  import * as echarts from 'echarts';
	export default {
		name: "Four",
		data() {
      return {
        Chart:null,
        option:null,
        config1:{
           // header: ['关口', '出口贸易额', '出口贸易额'],
            data: [
              ['新喀里多尼亚', '3848858.1300','543462.0000'],
              ['法国', '3848858.1300','543462.0000'],
              ['芬兰', '3848858.1300','543462.0000'],
              ['克罗地亚', '3848858.1300','543462.0000'],
              ['澳大利亚', '3848858.1300','543462.0000'],
              ['纳米比亚', '3848858.1300','543462.0000'],
              ['埃塞俄比亚', '3848858.1300','543462.0000'],
              ['列支敦士登', '3848858.1300','543462.0000'],
              ['智利', '3848858.1300','543462.0000'],
              ['哥斯达黎加', '3848858.1300','543462.0000'],
              ['冈比亚', '3848858.1300','543462.0000'],
              ['土耳其', '3848858.1300','543462.0000'],
            ],
            // index: true,
            columnWidth: [250, 170, 250],
            align: ['center'],
            rowNum: 7,
            headerBGC: '#1981f6',
            headerHeight: 45,
            oddRowBGC: 'rgba(0, 44, 81, 0.8)',
            evenRowBGC: 'rgba(10, 29, 50, 0.8)'
        },
      }
		},
    mounted() {
     // this.datainfo();
    },
    methods:{
      datainfo() {

      },
    }
	}

</script>

<style>
  .echart{
    display:flex;
    justify-content:center;
  }
  .box{
    position:relative;
  }
  .miniTitle{
    font-size:15px;
    color:#fff;
    display:flex;
    width:100%;
    position:absolute;
    top:65px;
  }
  .miniTitle span{
    width:50%;
    padding-left:15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/right/six.vue